import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Checkbox,
  Dropdown
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardConsultRequestListUX = (props: any) => {
    return(
      <div
        id="CardConsultRequestListUX-div-0"
        style={{ width: "100%", height: "auto", padding: "15px 15px 0px 10px" }}>
        <Form
          id="CardConsultRequestListUX-Form-2">
          <FormGroup
            id="CardConsultRequestListUX-FormGroup-3"
            inline={true}
            style={{marginBottom: "0.25rem"}}>
            <FormField
              id="CardConsultRequestListUX-FormField-71"
              width={(!props.isCardQueue && props.isWard) ? 2 : 3}>
              <label
                id="CardConsultRequestListUX-label-73">
                {props.languageUX === "en" ? "Find Patients" : "ค้นหาผู้ป่วย"}
              </label>
            </FormField>
            <FormField
              id="CardConsultRequestListUX-FormField-4"
              width={4}>
              <label
                id="CardConsultRequestListUX-label-6">
                {props.languageUX === "en" ? "Consultation appointment date" : "วันที่นัดส่งปรึกษา"}
              </label>
            </FormField>
            <FormField
              id="CardConsultRequestListUX-FormField-8"
              style={{ display: !props.isCardQueue && props.isWard ? "" : "none" }}
              width={(!props.isCardQueue && props.isWard) ? 2 : 3}>
              <label
                id="CardConsultRequestListUX-label-9">
                {props.languageUX === "en" ? "Referring physician" : "แพทย์ผู้ส่งปรึกษา"}
              </label>
            </FormField>
            <FormField
              id="CardConsultRequestListUX-FormField-5"
              width={(!props.isCardQueue && props.isWard) ? 2 : 3}>
              <label
                id="CardConsultRequestListUX-label-7">
                {props.languageUX === "en" ? "To the department" : "ถึงแผนก"}
              </label>
            </FormField>
            <FormField
              id="CardConsultRequestListUX-FormField-58"
              width={(!props.isCardQueue && props.isWard) ? 2 : 3}>
              <div
                id="CardConsultRequestListUX-div-75"
                style={{width:"100%"}}>
                
                <label
                  id="CardConsultRequestListUX-label-59"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Consulting Physician" : "แพทย์ผู้รับปรึกษา"}
                </label>
                <Checkbox
                  checked={props.filterParams?.noDoctor || false}
                  disabled={props.filterParams?.consulted_doctor}
                  id="CardConsultRequestListUX-Checkbox-18"
                  label={props.languageUX === "en" ? "Not yet specified" : "ยังไม่ระบุ"}
                  name="noDoctor"
                  onChange={(_event: any, data: any)=> props.onChangeValue(null, {value: data.checked, name: data.name})}
                  style={{marginLeft:"10px"}}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardConsultRequestListUX-FormField-12"
              width={(!props.isCardQueue && props.isWard) ? 2 : 3}>
              <label
                id="CardConsultRequestListUX-label-13">
                {props.languageUX === "en" ? "Appointment status" : "สถานะการนัดหมาย"}
              </label>
            </FormField>
            <FormField
              id="CardConsultRequestListUX-FormField-14"
              style={{ display: !props.isCardQueue && props.isWard ? "" : "none" }}
              width={(!props.isCardQueue && props.isWard) ? 2 : ""}>
              <label
                id="CardConsultRequestListUX-label-15">
                {props.languageUX === "en" ? "Consultation status" : "สถานะการ Consult"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardConsultRequestListUX-FormGroup-19"
            inline={true}>
            <FormField
              id="CardConsultRequestListUX-FormField-72"
              width={(!props.isCardQueue && props.isWard) ? 2 : 3}>
              <div
                id="CardConsultRequestListUX-div-74"
                style={{width: "100%"}}>
                {props.patientSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardConsultRequestListUX-FormField-20"
              width={4}>
              <div
                id="CardConsultRequestListUX-div-62"
                style={{ width: "50%" }}>
                
                <DateTextBox
                  id="CardConsultRequestListUX-DateTextBox-34"
                  onChange={(date: string)=> props.onChangeValue(null, {value: date, name: "start_app_date"})}
                  value={props.filterParams?.start_app_date || ""}>
                </DateTextBox>
              </div>
              <label
                id="CardConsultRequestListUX-label-44"
                style={{marginRight: "0.75rem"}}>
                {props.languageUX === "en" ? "to" : "ถึง"}
              </label>
              <div
                id="CardConsultRequestListUX-div-63"
                style={{ width: "50%" }}>
                
                <DateTextBox
                  id="CardConsultRequestListUX-DateTextBox-45"
                  onChange={(date: string)=> props.onChangeValue(null, {value: date, name: "end_app_date"})}
                  value={props.filterParams?.end_app_date || ""}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardConsultRequestListUX-FormField-26"
              style={{ display: !props.isCardQueue && props.isWard ? "" : "none" }}
              width={(!props.isCardQueue && props.isWard) ? 2 : 3}>
              <div
                id="CardConsultRequestListUX-div-47"
                style={{ width: "100%" }}>
                {props.doctorRequestSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardConsultRequestListUX-FormField-24"
              width={(!props.isCardQueue && props.isWard) ? 2 : 3}>
              <div
                id="CardConsultRequestListUX-div-46"
                style={{ width: "100%" }}>
                {props.divisionSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardConsultRequestListUX-FormField-60"
              width={(!props.isCardQueue && props.isWard) ? 2 : 3}>
              <div
                id="CardConsultRequestListUX-div-61"
                style={{ width: "100%" }}>
                {props.doctorAcceptSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardConsultRequestListUX-FormField-28"
              width={(!props.isCardQueue && props.isWard) ? 2 : 3}>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardConsultRequestListUX-Dropdown-38"
                name="app_status"
                onChange={props.onChangeValue}
                options={props.appointmentStatusOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filterParams?.app_status}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardConsultRequestListUX-FormField-30"
              style={{ display: !props.isCardQueue && props.isWard ? "" : "none" }}
              width={(!props.isCardQueue && props.isWard) ? 2 : 3}>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardConsultRequestListUX-Dropdown-39"
                name="status"
                onChange={props.onChangeValue}
                options={props.consultStatusOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filterParams?.status}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardConsultRequestListUX-FormField-66"
              style={{ display: !props.isCardQueue && props.isWard ? "" : "none" }}
              width={(!props.isCardQueue && props.isWard) ? 2 : 0}>
              <div
                id="CardConsultRequestListUX-div-70">
                {props.buttonSearch}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardConsultRequestListUX-FormGroup-91"
            inline={true}
            style={{ display: props.isWard ? "" : "none" }}>
            <FormField
              id="CardConsultRequestListUX-FormField-57"
              width={3}>
            </FormField>
            <FormField
              id="CardConsultRequestListUX-FormField-55"
              width={4}>
              <label
                id="CardConsultRequestListUX-label-56">
                {props.languageUX === "en" ? "Encounter type" : "ประเภท Encounter"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardConsultRequestListUX-FormGroup-54"
            inline={true}
            style={{ display: props.isWard ? "none" : "" , marginBottom: "0.25rem"}}>
            <FormField
              id="CardConsultRequestListUX-FormField-77"
              width={3}>
              <label
                id="CardConsultRequestListUX-label-83">
                {props.languageUX === "en" ? "Consultation status" : "สถานะการ Consult"}
              </label>
            </FormField>
            <FormField
              id="CardConsultRequestListUX-FormField-78"
              width={3}>
              <label
                id="CardConsultRequestListUX-label-17">
                {props.languageUX === "en" ? "Encounter type" : "ประเภท Encounter"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardConsultRequestListUX-FormGroup-92"
            inline={true}
            style={{ display: props.isWard ? "" : "none" }}>
            <FormField
              id="CardConsultRequestListUX-FormField-49"
              width={3}>
              <Checkbox
                checked={props.filterParams?.current_encounter}
                id="CardConsultRequestListUX-Checkbox-52"
                label={props.languageUX === "en" ? "Only current Encounter" : "เฉพาะ Encounter ปัจจุบัน"}
                name="current_encounter"
                onChange={(_event: any, data: any)=> props.onChangeValue(null, {value: data.checked, name: data.name})}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardConsultRequestListUX-FormField-51"
              width={3}>
              <Dropdown
                clearable={true}
                disabled={props.filterParams?.current_encounter}
                id="CardConsultRequestListUX-Dropdown-53"
                name="encounter_type"
                onChange={props.onChangeValue}
                options={props.encounterType || []}
                search={true }
                selection={true}
                value={props.filterParams?.encounter_type}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardConsultRequestListUX-FormField-93"
              inline={true}
              width={2}>
              <div
                id="CardConsultRequestListUX-div-94"
                style={{justifyContent: "flex-end", display: "flex", width: "100%"}}>
                {props.buttonSearch}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardConsultRequestListUX-FormGroup-48"
            inline={true}
            style={{ display: props.isWard ? "none" : "" }}>
            <FormField
              id="CardConsultRequestListUX-FormField-80"
              inline={true}
              width={3}>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardConsultRequestListUX-Dropdown-89"
                name="status"
                onChange={props.onChangeValue}
                options={props.consultStatusOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filterParams?.status}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardConsultRequestListUX-FormField-81"
              inline={true}
              width={3}>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardConsultRequestListUX-Dropdown-40"
                name="encounter_type"
                onChange={props.onChangeValue}
                options={props.encounterType || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filterParams?.encounter_type}>
              </Dropdown>
            </FormField>
            <div
              id="CardConsultRequestListUX-div-85"
              style={{flex:1}}>
              
            </div>
            <FormField
              id="CardConsultRequestListUX-FormField-86"
              inline={true}
              width={2}>
              <div
                id="CardConsultRequestListUX-div-87"
                style={{justifyContent: "flex-end", display: "flex", width: "100%"}}>
                {props.buttonSearch}
              </div>
            </FormField>
          </FormGroup>
        </Form>
        <Table
          data={props.tableData}
          defaultPageSize={10}
          headers={props.tableHeader}
          id="CardConsultRequestListUX-Table-43"
          keys={props.tableKeys}
          widths="130, 130, 300, 300, 140, 180, 180,">
        </Table>
      </div>
    )
}


export default CardConsultRequestListUX

export const screenPropsDefault = {"language":"TH"}

/* Date Time : Thu Nov 20 2025 07:17:11 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"auto\", padding: \"15px 15px 0px 10px\" }"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-Form-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormGroup-3"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.25rem\"}"
        },
        "widths": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-4"
        },
        "inline": {
          "type": "value",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-5"
        },
        "width": {
          "type": "code",
          "value": "(!props.isCardQueue && props.isWard) ? 2 : 3"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "label",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่นัดส่งปรึกษา",
          "valueEN": "Consultation appointment date"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-label-6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึงแผนก",
          "valueEN": "To the department"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-label-7"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-8"
        },
        "inline": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: !props.isCardQueue && props.isWard ? \"\" : \"none\" }"
        },
        "width": {
          "type": "code",
          "value": "(!props.isCardQueue && props.isWard) ? 2 : 3"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "label",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์ผู้ส่งปรึกษา",
          "valueEN": "Referring physician"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-label-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-12"
        },
        "inline": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "(!props.isCardQueue && props.isWard) ? 2 : 3"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะการนัดหมาย",
          "valueEN": "Appointment status"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-label-13"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-14"
        },
        "inline": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: !props.isCardQueue && props.isWard ? \"\" : \"none\" }"
        },
        "width": {
          "type": "code",
          "value": "(!props.isCardQueue && props.isWard) ? 2 : \"\""
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "label",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะการ Consult",
          "valueEN": "Consultation status"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-label-15"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "label",
      "parent": 78,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภท Encounter",
          "valueEN": "Encounter type"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-label-17"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "Checkbox",
      "parent": 75,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterParams?.noDoctor || false"
        },
        "disabled": {
          "type": "code",
          "value": "props.filterParams?.consulted_doctor"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-Checkbox-18"
        },
        "label": {
          "type": "value",
          "value": "ยังไม่ระบุ",
          "valueEN": "Not yet specified"
        },
        "name": {
          "type": "value",
          "value": "noDoctor"
        },
        "onChange": {
          "type": "code",
          "value": "(_event: any, data: any)=> props.onChangeValue(null, {value: data.checked, name: data.name})"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"10px\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormGroup-19"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "widths": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-20"
        },
        "inline": {
          "type": "value",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-24"
        },
        "inline": {
          "type": "value",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "(!props.isCardQueue && props.isWard) ? 2 : 3"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-26"
        },
        "inline": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: !props.isCardQueue && props.isWard ? \"\" : \"none\" }"
        },
        "width": {
          "type": "code",
          "value": "(!props.isCardQueue && props.isWard) ? 2 : 3"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-28"
        },
        "inline": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "(!props.isCardQueue && props.isWard) ? 2 : 3"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-30"
        },
        "inline": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: !props.isCardQueue && props.isWard ? \"\" : \"none\" }"
        },
        "width": {
          "type": "code",
          "value": "(!props.isCardQueue && props.isWard) ? 2 : 3"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 34,
      "name": "DateTextBox",
      "parent": 62,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-DateTextBox-34"
        },
        "onChange": {
          "type": "code",
          "value": "(date: string)=> props.onChangeValue(null, {value: date, name: \"start_app_date\"})"
        },
        "value": {
          "type": "code",
          "value": "props.filterParams?.start_app_date || \"\""
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "Dropdown",
      "parent": 28,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-Dropdown-38"
        },
        "name": {
          "type": "value",
          "value": "app_status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.appointmentStatusOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterParams?.app_status"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "Dropdown",
      "parent": 30,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-Dropdown-39"
        },
        "name": {
          "type": "value",
          "value": "status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.consultStatusOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterParams?.status"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "Dropdown",
      "parent": 81,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-Dropdown-40"
        },
        "name": {
          "type": "value",
          "value": "encounter_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.encounterType || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterParams?.encounter_type"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 43,
      "name": "Table",
      "parent": 0,
      "props": {
        "data": {
          "type": "code",
          "value": "props.tableData"
        },
        "defaultPageSize": {
          "type": "code",
          "value": "10"
        },
        "headers": {
          "type": "code",
          "value": "props.tableHeader"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-Table-43"
        },
        "keys": {
          "type": "code",
          "value": "props.tableKeys"
        },
        "pageSize": {
          "type": "value",
          "value": ""
        },
        "widths": {
          "type": "value",
          "value": "130, 130, 300, 300, 140, 180, 180,"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-label-44"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.75rem\"}"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 45,
      "name": "DateTextBox",
      "parent": 63,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-DateTextBox-45"
        },
        "onChange": {
          "type": "code",
          "value": "(date: string)=> props.onChangeValue(null, {value: date, name: \"end_app_date\"})"
        },
        "value": {
          "type": "code",
          "value": "props.filterParams?.end_app_date || \"\""
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "code",
          "value": "props.divisionSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-div-46"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctorRequestSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-div-47"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormGroup-48"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.isWard ? \"none\" : \"\" }"
        },
        "widths": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "FormField",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-49"
        },
        "inline": {
          "type": "value",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "FormField",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-51"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "Checkbox",
      "parent": 49,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterParams?.current_encounter"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-Checkbox-52"
        },
        "label": {
          "type": "value",
          "value": "เฉพาะ Encounter ปัจจุบัน",
          "valueEN": "Only current Encounter"
        },
        "name": {
          "type": "value",
          "value": "current_encounter"
        },
        "onChange": {
          "type": "code",
          "value": "(_event: any, data: any)=> props.onChangeValue(null, {value: data.checked, name: data.name})"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "Dropdown",
      "parent": 51,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.filterParams?.current_encounter"
        },
        "fluid": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-Dropdown-53"
        },
        "name": {
          "type": "value",
          "value": "encounter_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.encounterType || []"
        },
        "search": {
          "type": "code",
          "value": "true "
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.filterParams?.encounter_type"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormGroup-54"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.isWard ? \"none\" : \"\" , marginBottom: \"0.25rem\"}"
        },
        "widths": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "FormField",
      "parent": 91,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-55"
        },
        "inline": {
          "type": "value",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "label",
      "parent": 55,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภท Encounter",
          "valueEN": "Encounter type"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-label-56"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "FormField",
      "parent": 91,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-57"
        },
        "inline": {
          "type": "value",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-58"
        },
        "inline": {
          "type": "value",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "(!props.isCardQueue && props.isWard) ? 2 : 3"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "label",
      "parent": 75,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์ผู้รับปรึกษา",
          "valueEN": "Consulting Physician"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-label-59"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-60"
        },
        "inline": {
          "type": "value",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "(!props.isCardQueue && props.isWard) ? 2 : 3"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 60,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctorAcceptSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-div-62"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\" }"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-div-63"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\" }"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-66"
        },
        "inline": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: !props.isCardQueue && props.isWard ? \"\" : \"none\" }"
        },
        "width": {
          "type": "code",
          "value": "(!props.isCardQueue && props.isWard) ? 2 : 0"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-div-70"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 71,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-71"
        },
        "width": {
          "type": "code",
          "value": "(!props.isCardQueue && props.isWard) ? 2 : 3"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 72,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-72"
        },
        "width": {
          "type": "code",
          "value": "(!props.isCardQueue && props.isWard) ? 2 : 3"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "label",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหาผู้ป่วย",
          "valueEN": "Find Patients"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-label-73"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "div",
      "parent": 72,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-div-74"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "div",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-div-75"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 77,
      "name": "FormField",
      "parent": 54,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-77"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "FormField",
      "parent": 54,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-78"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 80,
      "name": "FormField",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-80"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "value",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "FormField",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-81"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "value",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "label",
      "parent": 77,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะการ Consult",
          "valueEN": "Consultation status"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-label-83"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "div",
      "parent": 48,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-div-85"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "FormField",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-86"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 86,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-div-87"
        },
        "style": {
          "type": "code",
          "value": "{justifyContent: \"flex-end\", display: \"flex\", width: \"100%\"}"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "Dropdown",
      "parent": 80,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-Dropdown-89"
        },
        "name": {
          "type": "value",
          "value": "status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.consultStatusOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterParams?.status"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormGroup-91"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.isWard ? \"\" : \"none\" }"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 92,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormGroup-92"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.isWard ? \"\" : \"none\" }"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 93,
      "name": "FormField",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-FormField-93"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 93,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardConsultRequestListUX-div-94"
        },
        "style": {
          "type": "code",
          "value": "{justifyContent: \"flex-end\", display: \"flex\", width: \"100%\"}"
        }
      },
      "seq": 94,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardConsultRequestListUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 80
}

*********************************************************************************** */
